import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Section from 'helpers/Section';
import LazyImage from 'helpers/LazyImage';
import Avis from 'assets/images/carsLogo/avis_logo.svg';
import Hertz from 'assets/images/carsLogo/hertz_logo.svg';
import Budget from 'assets/images/carsLogo/budget_logo.svg';
import Thrifty from 'assets/images/carsLogo/thrifty_logo.svg';
import Europcar from 'assets/images/carsLogo/europcar_logo.svg';
import National from 'assets/images/carsLogo/national_logo.svg';

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 6,
  arrows: true,
  responsive: [{
    breakpoint: 800,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }]
};

const items = [
  {
    img: Avis,
    title: 'Avis Logo'
  },
  {
    img: Europcar,
    title: 'Europcar logo'
  },
  {
    img: Hertz,
    title: 'Hertz logo'
  },
  {
    img: Thrifty,
    title: 'Thrifty logo'
  },
  {
    img: Budget,
    title: 'Budget logo"'
  },
  {
    img: National,
    title: 'National logo'
  }
];

const slides = items.map((item, i) => (
  <LazyImage key={i} imgClass="card-img-top" src={item.img} alt={item.title} title={item.title} />
));

const PopularCompanies = ({translations: {title}}) => (
  <Section
    sectionClass="text-center bg-white py-4"
    renderTitle={() => (<p className="text-lead">{title}</p>)}
  >
    <Slider {...settings}>
      {slides}
    </Slider>
  </Section>
);

PopularCompanies.propTypes = {
  translations: PropTypes.shape({
    title: PropTypes.string.isRequired
  })
};

export default PopularCompanies;
